// Maps Australian state names (STATE_NAME in australia-states.geojson) to the
// per-state POA polygon file under /geojson/australia/{file}.geojson.
// POA = Postal Area; each feature's properties.postcode holds the 4-digit code.
export const AUSTRALIA_STATE_FILES: Record<string, string> = {
  'New South Wales': 'nsw',
  Victoria: 'vic',
  Queensland: 'qld',
  'South Australia': 'sa',
  'Western Australia': 'wa',
  Tasmania: 'tas',
  'Northern Territory': 'nt',
  'Australian Capital Territory': 'act',
};
